import { render, staticRenderFns } from "./AIAutoDialerDashboard.vue?vue&type=template&id=2f9e254e&"
import script from "./AIAutoDialerDashboard.vue?vue&type=script&lang=js&"
export * from "./AIAutoDialerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports